import ko from 'knockout';
import { customFetch as fetch } from '../fetch';

export class KvkSearchResultModel {
    kvkNumber: KnockoutObservable<string>;
    companyName: KnockoutObservable<string>;
    address: KnockoutObservable<string>;
    city: KnockoutObservable<string>;

    fullAddress: KnockoutComputed<string>;

    constructor(model: any) {
        this.kvkNumber = ko.observable<string>(model.kvkNumber);
        this.companyName = ko.observable<string>(model.companyName);

        this.address = ko.observable<string>(model.address.address.street);
        this.city = ko.observable<string>(model.address.address.city);
        this.fullAddress = ko.pureComputed(() => {
            return `${this.address()}, ${this.city()}`;
        });
    }
}

export function searchCompanies(searchString: string) {
    return fetch(encodeURI(`/kvkapi/search?q=${searchString}`), {
        method: 'get',
    });
}
